import { Center } from '@chakra-ui/layout'
import { Image, Text, useMediaQuery } from '@chakra-ui/react'
import { Link as RouteLink } from 'react-router-dom'
import type { APIUser } from '../api'
import { notAuthenticatedDesktop, notAuthenticatedMobile } from '../assets/svg'
import { useUserAwareTranslation } from '../i18n/hooks'
import { ButtonPrimary } from './Base'

interface NoMatchProps {
  user?: APIUser
  qs?: string
}

const NoMatch = (props: NoMatchProps) => {
  const { user, qs = '' } = props
  const { t } = useUserAwareTranslation(user)
  const [isMobile] = useMediaQuery('(max-width: 479px)')
  return (
    <Center flexDirection={'column'} pt="200">
      <Image src={isMobile ? notAuthenticatedMobile : notAuthenticatedDesktop} />
      <Text
        as="h3"
        fontWeight="400"
        fontFamily="Noto Serif"
        fontSize={['2xl', '4xl']}
        textAlign="center"
        w={isMobile ? 250 : '100%'}
        p={10}>
        {t('page-not-found')}
      </Text>
      <RouteLink to={`/${qs}`}>
        <ButtonPrimary w="100%">{t('return-home')}</ButtonPrimary>
      </RouteLink>
    </Center>
  )
}

export default NoMatch
